import { List } from 'immutable';
import { effectState } from './effects';
export var state = List.of(effectState);